import React from 'react';
import {CustomCard} from './styles';
import {ResponsiveCardProps} from './types';

export function ResponsiveCard({children, height, ...props}: ResponsiveCardProps) {
	return (
		<CustomCard variant="outlined" height={height} {...props}>
			{children}
		</CustomCard>
	);
}
